export function planHasCdn(instance) {
  const slug = instance?.plan_settings?.cdn?.provider_slug;
  return typeof slug === "string" && slug !== "" && slug !== "none";
}

export function cdnDnsRecords(instance) {
  if (!planHasCdn(instance)) {
    return [];
  }
  return Array.isArray(instance?.cdn_dns_records) ? instance.cdn_dns_records : [];
}

export function cdnDnsPending(instance) {
  return planHasCdn(instance) && cdnDnsRecords(instance).length === 0;
}

export function cdnAValues(instance) {
  return cdnDnsRecords(instance)
    .filter((record) => record && record.type === "A" && record.value)
    .map((record) => record.value);
}

export function skipARecordVerification(instance) {
  return cdnDnsPending(instance);
}
